<script lang="ts">
	import { browser } from '$app/env';
	import { goto } from '$app/navigation';
	import { page } from '$app/state';
	import { buildListingDetailPath } from '$lib/geo';
	import { localizeHref } from '@/paraglide/runtime';
	import {
		Collections,
		type BoatsResponse,
		type ListingsResponse,
		type PortsResponse
	} from '@/pocketbase/pocketbase-types';
	import { pb } from '@/utils/ApiClient';

	// Ruta legacy: /alquiler-barco?id=... redirige a la URL canónica
	// /barcos/alquiler/{comunidad}/{provincia}/{ciudad}/{id}.
	$effect(() => {
		redirect();
	});

	async function redirect() {
		if (!browser) return;
		const id = page.url.searchParams.get('id');
		if (!id) {
			goto(localizeHref('/'), { replaceState: true });
			return;
		}
		try {
			const listing = await pb.collection(Collections.Listings).getOne<
				ListingsResponse & {
					expand?: { boat?: BoatsResponse & { expand?: { port?: PortsResponse } } };
				}
			>(id, { expand: 'boat.port' });
			const port = listing.expand?.boat?.expand?.port ?? null;
			goto(localizeHref(buildListingDetailPath(listing, port)), { replaceState: true });
		} catch (error) {
			console.error('Error al obtener el listado:', error);
			goto(localizeHref('/'), { replaceState: true });
		}
	}
</script>

<svelte:head>
	<meta name="robots" content="noindex, follow" />
</svelte:head>

<div class="flex min-h-[50vh] items-center justify-center">
	<p class="text-muted-foreground text-sm">Redirigiendo al anuncio…</p>
</div>
